export const ALTERNATE_SOURCE_STATUS = {
  MATCH: 'match',
  MISMATCH: 'mismatch',
  UNSET: 'unset',
};

export const BOOKS_MAPPING_STATUS = {
  MAPPED: 'mapped',
  UNKNOWN: 'unknown',
  UNMAPPED: 'unmapped',
  UNREGISTERED: 'unregistered',
};

export const ALTERNATE_SOURCE_STATUS_CONFIG = {
  [ALTERNATE_SOURCE_STATUS.MATCH]: {
    iconClassName: 'fa fa-check-circle',
    iconColor: 'green',
    iconTitle: 'Match between Knock and Books',
  },
  [ALTERNATE_SOURCE_STATUS.MISMATCH]: {
    iconClassName: 'fa fa-exclamation-circle',
    iconTitle: 'Mismatch between Knock and Books',
    iconColor: 'orange',
  },
  [ALTERNATE_SOURCE_STATUS.UNSET]: {
    iconClassName: 'fa fa-minus-circle',
    iconColor: 'grey',
    iconTitle: 'Not set',
  },
};

export const MAPPING_STATUS_CONFIG = {
  [BOOKS_MAPPING_STATUS.MAPPED]: {
    iconClassName: 'fa fa-check-circle mapped',
    iconColor: 'green',
    iconTitle: 'Property Mapped',
    label: 'Mapped',
  },
  [BOOKS_MAPPING_STATUS.UNKNOWN]: {
    iconClassName: 'fa fa-minus-circle unknown',
    iconColor: 'grey',
    iconTitle: 'Not set',
    label: 'Unknown',
  },
  [BOOKS_MAPPING_STATUS.UNMAPPED]: {
    iconClassName: 'fa fa-exclamation-circle unmapped',
    iconTitle: 'Property exist in Books but not mapped',
    iconColor: 'orange',
    label: 'Unmapped',
  },
  [BOOKS_MAPPING_STATUS.UNREGISTERED]: {
    iconClassName: 'fa fa-exclamation-circle unregistered',
    iconColor: 'red',
    iconTitle: 'Unregistered property',
    label: 'Unregistered',
  },
};
